import Vue from 'vue';
import { MutationTree } from 'vuex';
import { StartpageModule } from './types';
import { crmapi } from '@/types/crm-types';

export const mutations: MutationTree<StartpageModule> = {

  projectsLoaded(state, payload: crmapi.Project[]) {
    state.projects = payload;
  },
  setSearchstring(state, payload: string) {
    state.searchstring = payload;
  },
};
